import React from 'react';
import { Button } from 'oui-react';
import bandwidthStore from '../store/bandwidth';
import InputText from './InputText';

const UserInputForm = (props) => {
  const bandwidthState = props.state;

  const handleChange = (e) => {
    e.preventDefault();
    const val = e.target.value;
    bandwidthStore.updateAmount(e.target.value);
    bandwidthState.category === 'bandwidth' ? bandwidthStore.calculateBandwidth(val)
                : (bandwidthState.category === 'block' ? bandwidthStore.calculateBlock(val)
                : (bandwidthState.category === 'hpc' ? bandwidthStore.calculateStdCompute(val, bandwidthState.cores, bandwidthState.blockVol)
                : bandwidthStore.selectCategory(props.items.id)));
    bandwidthStore.calculateSliderConstants(val);
    bandwidthStore.calculateValues();
    bandwidthStore.calculateTotalValues();
    bandwidthStore.calculateSavings();
    
  };

  const handleBYOValuesChange = (e) => {
    e.preventDefault();
    const target = e.target;
    const val = target.name === 'egress' ? target.value : (target.name === 'blockStorage' ? target.value 
            : (target.name === 'gpuServices' ? target.value : (target.name === 'stdCompute' ? target.value : '')));
    const name = target.name;
    bandwidthStore.updateBYOValues(name, val);
    name === 'egress' ? bandwidthStore.calculateBandwidth(val) 
                  : (name === 'blockStorage' ? bandwidthStore.calculateBlock(val) 
                  // : (name === 'gpuServices' ? bandwidthStore.calculateHpc(val)
                  : (name === 'stdCompute' ? bandwidthStore.calculateCompute(val)
                  : bandwidthStore.updateBYOValues(name, val)));
    bandwidthStore.calculateBYOTotalValues();
    bandwidthStore.calculateBYOSavings();
  }

  const onSubmit = (e) => {
    e.preventDefault();
    bandwidthStore.hideSubmitButton();
    bandwidthStore.showResults();
  };

  return (
    <div className="egressForm">
      <div className="row">
        <div className="col-xs-12">
          <h6>{props.items.title}</h6>
        </div>
      </div>
        
      {props.items.id === 'own' ? 
        <div className="row">
          <div className="col-xs-3">
            <InputText type="number" label="Network Egress (TB)" name="egress" value={bandwidthState.egress} onChange={e => handleBYOValuesChange(e)}></InputText>
          </div>
          <div className="col-xs-3">
            <InputText type="number" label="High IO Block Storage (TB)" name="blockStorage" value={bandwidthState.blockStorage} onChange={e => handleBYOValuesChange(e)}></InputText>
          </div>
          <div className="col-xs-3">
            <InputText type="number" label="Standard Compute (OCPUs/Hour)" name="stdCompute" value={bandwidthState.stdCompute} onChange={e => handleBYOValuesChange(e)}></InputText>
          </div>
          {/* <div className="col-xs-3">
            <InputText type="number" label="GPU/HPC Services (GPU Hours)" name="gpuServices" value={bandwidthState.gpuServices} onChange={e => handleBYOValuesChange(e)}></InputText>
          </div> */}
        </div>

        :
        <div className="row">
          <div className="col-xs-6">
            <InputText type="number" label={props.items.name} name="amount" value={bandwidthState.amount} onChange={e => handleChange(e)}></InputText>
          </div>
        </div>
      }
    
      <div>
        {bandwidthState.showButton &&
          <div className="float-right">
            <Button className="egressBtn" onClick={e => onSubmit(e)} >Estimate My Savings</Button>
          </div>
        }
      </div>
    </div>
  );
};

export default UserInputForm;
